import { render, staticRenderFns } from "./vessel-detail-activity.vue?vue&type=template&id=6a545359&scoped=true"
import script from "./vessel-detail-activity.vue?vue&type=script&lang=js"
export * from "./vessel-detail-activity.vue?vue&type=script&lang=js"
import style0 from "./vessel-detail-activity.vue?vue&type=style&index=0&id=6a545359&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a545359",
  null
  
)

export default component.exports